import { ReferentielModel } from './referentiel.model';

export class BoxSetItemModel {
  public id: number = null;
  public support: ReferentielModel = new ReferentielModel();
  public ean: string = null;
  public title: string = null;
  public financialDistributionInitialized: boolean;
  public idWorks: number[] = [];
  public formattedEan: string;

  constructor() {}

  public fromJSON(json) {
    for (const propName in json) {
      if (json.hasOwnProperty(propName)) {
        this[propName] = json[propName];
      }
    }
    return this;
  }
}
